import React, { useEffect } from 'react';

import FullscreenLoader from '../../components/FullscreenLoader';
import { IndexPath } from '../../routing';
import { useAuth } from 'oidc-react';
import { useHistory } from 'react-router-dom';

export default function SignOut() {
  const auth = useAuth();
  const history = useHistory();

  useEffect(() => {
    if (auth.isLoading) {
      return;
    }
    if (!auth.userData) {
      history.replace(IndexPath);
      return;
    }
    void auth.signOutRedirect().catch(() => {
      history.replace(IndexPath);
    });
  }, [auth.isLoading, auth.userData, auth.signOutRedirect, history]);

  return <FullscreenLoader />;
}
